import { create } from "zustand";

// LQC-1733 - the RP quotes as the server last sent them, keyed by esid. Local edits
// write into tradeData directly, so this is the only record of what was quoted.

export type QuoteSnapshotValue = string | number | null | undefined;

export interface IQuoteSidesSnapshot {
  bid: QuoteSnapshotValue;
  ask: QuoteSnapshotValue;
}

// Top-level sides are the spread, or block 0 on an outright (ES/ER act as the leg).
export interface IQuoteSnapshot extends IQuoteSidesSnapshot {
  blocks: Record<number, IQuoteSidesSnapshot>;
}

type State = {
  quoteSnapshots: Record<string, IQuoteSnapshot>;
};

type Actions = {
  replaceQuoteSnapshots: (snapshots: Record<string, IQuoteSnapshot>) => void;
  mergeQuoteSnapshots: (snapshots: Record<string, IQuoteSnapshot>) => void;
};

const quoteSnapshotStore = create<State & Actions>((set) => ({
  quoteSnapshots: {},
  replaceQuoteSnapshots: (snapshots) => set({ quoteSnapshots: snapshots }),
  mergeQuoteSnapshots: (snapshots) =>
    set((state) => ({
      quoteSnapshots: { ...state.quoteSnapshots, ...snapshots },
    })),
}));

export default quoteSnapshotStore;
